import { filterByGameLocationsAndResults } from '@/utils/playsFiltering';
import { getPlayerTableData } from '@/utils/playerTableData';
import { getSoccerGoalData } from '@/data/generators/soccerGoalData';
import playerStatsPlayIndexes from '@/data/player/playerStatsPlayIndexes';
import playerGoalPlayIndexes from '@/data/player/playerGoalPlayIndexes';
import { getChalkboardPlayList, getChalkboardGames } from '@/data/generators/soccerChalkboardData';

const state = {
  basePlaysStack: [],
  goalPlaysStack: [],
};

const mutations = {
  updatePlaysStack(state, playsStack) {
    state.basePlaysStack = playsStack;
  },
  updateGoalPlaysStack(state, goalPlaysStack) {
    state.goalPlaysStack = goalPlaysStack;
  },
};

const getters = {
  getBasePlaysStack: state => state.basePlaysStack,
  filteredPlaysStack(state, getters, rootState, rootGetters) {
    return filterByGameLocationsAndResults(
      state.basePlaysStack,
      rootGetters['filterGeneral/getPlayingAs'],
      rootGetters['filterGeneral/getResults'],
      rootGetters['filterGeneral/getSelectedGamesIds'],
      playerStatsPlayIndexes(),
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  tableData(state, getters, rootState, rootGetters) {
    return getPlayerTableData(
      2,
      rootGetters['playersGeneral/player'].position_id === 1,
      getters.filteredPlaysStack,
      rootGetters['leagueGeneral/filteredPlaysStack'],
      rootGetters['filterGeneral/getSections'],
      rootGetters['filterGeneral/getGamesPlayed'],
    );
  },
  chalkboardPlays(state, getters, rootState, rootGetters) {
    return getChalkboardPlayList(
      getters.filteredPlaysStack,
      rootGetters['filterGeneral/getSections'],
      playerStatsPlayIndexes(),
    );
  },
  chalkboardGames(state, getters, rootState, rootGetters) {
    return getChalkboardGames(
      rootGetters['teamsGeneral/teamsForAnalysis'],
      rootGetters['gamesGeneral/seasonGamesPlayed'],
    );
  },
  goalPlays(state, getters, rootState, rootGetters) {
    return getSoccerGoalData(
      state.goalPlaysStack,
      rootGetters['filterGeneral/getPlayingAs'],
      rootGetters['filterGeneral/getResults'],
      rootGetters['filterGeneral/getSections'],
      rootGetters['filterGeneral/getSelectedGamesIds'],
      playerGoalPlayIndexes(),
    );
  },
  topFiveCategories() {
    return [
      {
        name: 'participación en goles',
        rank: 1,
        total: 44,
        max: 'owner',
      },
      {
        name: 'cabeceo área rival',
        rank: 2,
        total: 13,
        max: 20,
      },
      {
        name: 'tiros a gol',
        rank: 3,
        total: 20,
        max: 26,
      },
      {
        name: '1 vs 1 ofensivo exitoso',
        rank: 4,
        total: 22,
        max: 32,
      },
      {
        name: 'asistencias',
        rank: 4,
        total: 2,
        max: 4,
      },
    ];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
